import { Glass } from 'components/Glass';
import { ICONS, Icon } from 'components/Icon';
import { Pressable } from 'components/Pressable';
import { useSelector } from 'hooks/useSelector';
import { theme } from 'lib/theme';
import React from 'react';
import { View } from 'react-native';
import { useDispatch } from 'react-redux';
import {
  OPEN_BARCODE_SCANNER,
  doAseFieldInstanceSearchBarcode,
} from 'store/actions';
import { selectAseHasFieldInstancesWithQrData } from 'store/assessments/selectors';

const CIRCLE_SIZE = 68;
const ICON_SIZE = CIRCLE_SIZE / 2;
const ABSOLUTE_RIGHT_POSITION = 18;

export const QrIndicator: React.FC = () => {
  const dispatch = useDispatch();
  const hasFieldInstanceWithQrData = useSelector(
    selectAseHasFieldInstancesWithQrData,
  );

  if (!hasFieldInstanceWithQrData) {
    return null;
  }

  const handleFindByQrPress = () =>
    dispatch(
      OPEN_BARCODE_SCANNER({
        text: 'scan to find an existing element',
        actionAfter: doAseFieldInstanceSearchBarcode({
          data: '',
          parent: null,
        }),
      }),
    );

  return (
    <View
      style={{
        elevation: 5,
        zIndex: 9999,
        position: 'absolute',
        bottom: ABSOLUTE_RIGHT_POSITION,
        left: ABSOLUTE_RIGHT_POSITION,
        flexDirection: 'row',
        pointerEvents: 'box-none',
      }}
    >
      <Glass
        backgroundColor={theme.colors.black}
        tintColor={theme.colors.black}
        style={{ borderRadius: 99 }}
      >
        <Pressable
          style={{
            width: CIRCLE_SIZE,
            height: CIRCLE_SIZE,
            borderRadius: CIRCLE_SIZE,
            alignItems: 'center',
            justifyContent: 'center',
          }}
          pressedStyle={{
            opacity: 0.5,
          }}
          onPress={handleFindByQrPress}
        >
          <Icon
            source={ICONS.QRCodeLight}
            size={ICON_SIZE}
            color={theme.colors.white}
          />
        </Pressable>
      </Glass>
    </View>
  );
};
